interface TitledBrand {
  title: string
  flowTitle: string
}

/** Use the branded signup's own title, as the legacy pages did; fall back to the name-based flow title. */
export function signupPageTitle(brand: TitledBrand): string {
  const title = brand.title?.trim()
  return title ? title : brand.flowTitle
}
